import system from './system';
import translations from './translations';
import header from './header';
import footer from './footer';
import {recentActivityReducer} from '../recent-activity';
import {reducer as tripboard} from '../tripboard';
import trip from './trip';
import {tripboardButtonReducer} from '@homeaway/react-trip-board-button';
import {toasterReducers} from '@homeaway/react-toaster';
import onboardingReducer from '../components/onboarding/onboarding-reducer';

/**
 * Connect reducers to the redux store.
 */

/* istanbul ignore next */
const reducers = {
    footer,
    header,
    recentActivity: recentActivityReducer,
    system,
    onboarding: onboardingReducer,
    translations,
    tripboard,
    tripboardButton: tripboardButtonReducer,
    trip,
    toasts: toasterReducers
};

export default reducers;



// WEBPACK FOOTER //
// ./src/universal/reducers/all.js